module.exports = __webpack_public_path__ + "assets/img/title-f410f3d1.png";